import { render, staticRenderFns } from "./OzLabelInput.vue?vue&type=template&id=22547e2c&"
import script from "./OzLabelInput.vue?vue&type=script&setup=true&lang=ts&"
export * from "./OzLabelInput.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports